<div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
  <!-- Logo  -->
  <div *ngIf="showLogo" fxFlex="nogrow">
    <a (click)="goToUrl()" (keyup.enter)="goToUrl()" tabindex="0" class="pointer">
      <img
        [src]="imageUrl"
        [title]="titleHover"
        [attr.alt]="titleHover"
        style="max-width: 220px; max-height: 45px"
      />
    </a>
  </div>

  <!-- Title -->
  <a
    *ngIf="showTitle"
    tabindex="0"
    [title]="titleHover"
    [ngClass]="{ 'd-none d-lg-flex': responsive, pointer: true }"
    (click)="goToUrl()"
    (keyup.enter)="goToUrl()"
  >
    {{ title }}
  </a>
</div>
